import type { CanvasRecord } from "@canvaschool/contracts";

const formatDate = (value: string | null) =>
  value ? new Date(value).toLocaleString("ko-KR") : "-";

export const TrashPanel = ({
  trashed,
  canRestore,
  onRestore,
}: {
  trashed: CanvasRecord[];
  canRestore: boolean;
  onRestore: (canvas: CanvasRecord) => void;
}) => (
  <section
    aria-labelledby="canvaschool-trash-heading"
    className="canvaschool-no-print"
  >
    <h2 id="canvaschool-trash-heading">휴지통</h2>
    {trashed.length === 0 ? (
      <p>휴지통이 비어 있습니다.</p>
    ) : (
      <ul className="canvaschool-list">
        {trashed.map((canvas) => (
          <li key={canvas.id} className="canvaschool-trash-item">
            <div>
              <p className="canvaschool-trash-title">{canvas.title}</p>
              <p className="canvaschool-meta canvaschool-trash-meta">
                {formatDate(canvas.trashExpiresAt)}까지 복원 가능
              </p>
            </div>
            {canRestore && (
              <button
                type="button"
                className="canvaschool-btn-primary"
                aria-label={`${canvas.title} 복원`}
                onClick={() => onRestore(canvas)}
              >
                복원
              </button>
            )}
          </li>
        ))}
      </ul>
    )}
  </section>
);
